<template>
<div class="container-fluid" style="max-height: 100%; height: 100%; overflow: auto; padding-top: 20px; padding-bottom:20px;">
    <div class="row justify-content-center">
        <div class="container-fluid mt-6">
            <div class="row d-flex align-items-center flex-column justify-content-center">
                <div class="col-xl-6 text-center">
                    <h1 v-if="this.next_step == 1">Your publishing Agreement </h1>
                    <h1 v-if="this.next_step == 2">Please provide details about you and your art book</h1>
                    <h1 v-if="this.next_step == 3">Now let's create the book cover</h1>
                    <h1 v-if="this.next_step == 4">Please provide 7 images for the book mockups </h1>
                    <h1 v-if="this.next_step == 5">Now let's create the book cover</h1>
                    <h1 v-if="this.next_step == 6">Please checkout the cover proposals from your designer</h1>
                    <!-- h1 v-if="this.next_step == 7">Now let's create the book cover</h1-->
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
  import { Tooltip } from 'element-ui'
  export default {
    name: 'wizard-header',
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        ...mapState(
            {
                photo_book: (state) => state.photo_book,
            }),
        next_step: (state) => state.photo_book.photo_book.next_step,
    },
  };

</script>
